import { STG_ENV } from './stg-env'

export const ENVIROMENT_DEV = 'dev'
export const ENVIROMENT_TEST = 'test'
export const ENVIROMENT_QA = 'qa'
export const ENVIROMENT_DEMO = 'demo'
export const ENVIROMENT_STAGE = 'stage'
export const ENVIROMENT_STG = 'stg'
export const ENVIROMENT_PROD = 'prod'

export const ENVIROMENT_PREFIX_DEV = 'dev-'
export const ENVIROMENT_PREFIX_TEST = 'test-'
export const ENVIROMENT_PREFIX_QA = 'qa-'
export const ENVIROMENT_PREFIX_DEMO = 'demo-'
export const ENVIROMENT_PREFIX_STAGE = 'stage-'
export const ENVIROMENT_PREFIX_PROD = ''
const { hostname } = window.location
let environment = 'prod'

// localhost and dev-hostname result in a dev environment. stage-hostname will be stage environment
// ie: localhost:3000 or dev-app.hixme.com will be dev
// ie: stage-app.hixme.com will be stage
// default is prod
export function setEnvironmentWithHostname(useHostname = hostname) {
  if (
    useHostname === 'localhost' ||
    useHostname.startsWith(ENVIROMENT_PREFIX_DEV) ||
    useHostname.includes(`.${ENVIROMENT_DEV}`) ||
    useHostname.startsWith('192.168')
  ) {
    environment = ENVIROMENT_DEV
  } else if (useHostname.startsWith(ENVIROMENT_PREFIX_TEST)) {
    environment = ENVIROMENT_TEST
  } else if (useHostname.startsWith(ENVIROMENT_PREFIX_DEMO)) {
    environment = ENVIROMENT_DEMO
  } else if (useHostname.startsWith(ENVIROMENT_PREFIX_STAGE)) {
    environment = ENVIROMENT_STAGE
  } else if (useHostname.includes(`.${ENVIROMENT_STG}`)) {
    environment = ENVIROMENT_STG
  } else if (useHostname.startsWith(ENVIROMENT_PREFIX_QA)) {
    environment = ENVIROMENT_QA
  }
}

// set default environment
setEnvironmentWithHostname()

// helper functions
// Here dev and test are considered development environments
// Prod and demo are considered production level environments
export const isDevelopment = () =>
  environment === ENVIROMENT_DEV ||
  environment === ENVIROMENT_TEST ||
  environment === ENVIROMENT_QA
export const isStaging = () => environment === ENVIROMENT_STAGE
// stg is its own environment — intentionally NOT part of isProduction/isDevelopment/isStaging
export const isStg = () => environment === ENVIROMENT_STG
export const isTesting = () => environment === ENVIROMENT_TEST
export const isDemo = () => environment === ENVIROMENT_DEMO
export const isProduction = () =>
  environment === ENVIROMENT_PROD ||
  environment === ENVIROMENT_DEMO ||
  environment === ENVIROMENT_STAGE

export const getEnvironment = () => environment

export const isLocal = (useHostname = hostname) =>
  useHostname === 'localhost' || useHostname.startsWith('192.168')

// prefix used for url building, to keep testing consistent
// link from dev-admin.hixme.com can link to dev-enrollme.hixme.com
export const getEnvironmentPrefix = () => {
  if (environment === ENVIROMENT_DEV) {
    return ENVIROMENT_PREFIX_DEV
  } else if (environment === ENVIROMENT_TEST) {
    return ENVIROMENT_PREFIX_TEST
  } else if (environment === ENVIROMENT_QA) {
    return ENVIROMENT_PREFIX_QA
  } else if (environment === ENVIROMENT_DEMO) {
    return ENVIROMENT_PREFIX_DEMO
  } else if (environment === ENVIROMENT_STAGE) {
    return ENVIROMENT_PREFIX_STAGE
  }

  // production doesn't require a prefix
  return ''
}

export const getPaymentServiceKey = () => {
  if (isStg()) {
    return STG_ENV.paymentServiceKey
  }
  if (hostname === 'localhost') {
    return 'bWivhomTtd1ClVayfGMeAa15hWTmTgSq3Tdf6mej'
  }
  if (hostname.startsWith(ENVIROMENT_PREFIX_DEV)) {
    return 'TF0npF7kdtaWA4iZwlvqE1pVlaBMqoMU2W4lZbOs'
  }
  return ''
}

export const getPaymentServiceURL = () => {
  if (isStg()) {
    return STG_ENV.paymentServiceUrl
  }
  if (hostname === 'localhost') {
    return 'https://paymentservice.dev.surecolabs.com'
  }
  if (hostname.startsWith(ENVIROMENT_PREFIX_DEV)) {
    return 'https://paymentservice.qa.surecolabs.com'
  }
  return 'https://paymentservice.docday.com'
}

export const getLaunchDarklyConfig = () => {
  const LAUNCH_DARKLY_CONFIG_MAP = {
    dev: {
      clientSideID: '64791f86860a6912eed67bf6',
    },
    test: {
      clientSideID: '647e58b03eb05612f56036db',
    },
    demo: {
      clientSideID: '647e58b98fc16e13548ccd38',
    },
    stage: {
      clientSideID: '64791fcabd0c3a13ba779f84',
    },
    stg: {
      clientSideID: '6a39d49c0a01960a8a8fe8f7',
    },
    prod: {
      clientSideID: '64791f86860a6912eed67bf7',
    },
  }

  return LAUNCH_DARKLY_CONFIG_MAP[environment]
}

/**
 * Entra ID app registration "SureCo Admin Portal (SharePoint)" — single-tenant
 * SPA in the SureCo directory, shared by every environment. Delegated Graph
 * permissions (User.Read, Sites.Read.All, Files.ReadWrite.All) have admin
 * consent. See src/modules/sharepoint/README.md.
 */
export const MICROSOFT_GRAPH_CLIENT_ID = '9e5f77c5-0f4b-4032-bed4-aba5a2560be7'
export const MICROSOFT_GRAPH_TENANT_ID = 'f82bd569-15bf-4ed7-8826-f1bbf3b3fb53'

const MICROSOFT_GRAPH_NOT_CONFIGURED = {
  clientId: '',
  tenantId: '',
  siteIds: /** @type {string[]} */ ([]),
}

/**
 * Microsoft Graph / SharePoint portal configuration.
 *
 * MSAL redirects back to window.location.origin, so an environment may only
 * use the app registration if its origin is a registered redirect URI:
 * http://localhost:3000, https://admin.dev.surecolabs.com,
 * https://admin.stg.surecolabs.com, https://admin.sureco.com and
 * https://admin.hixme.com. Environments without one (test, stage, qa, demo)
 * stay unconfigured so the portal shows its setup message instead of a failed
 * Microsoft sign-in.
 */
export const getMicrosoftGraphConfig = () => {
  if (isStg()) {
    return {
      clientId: STG_ENV.microsoftGraphClientId,
      tenantId: STG_ENV.microsoftGraphTenantId,
      siteIds: STG_ENV.microsoftGraphSiteIds,
    }
  }

  // siteIds ({hostname},{site-collection-id},{site-id}) optionally pin which
  // SharePoint sites the portal offers; when empty it lists every site the
  // signed-in user can access.
  const CONFIG_MAP = {
    dev: {
      clientId: MICROSOFT_GRAPH_CLIENT_ID,
      tenantId: MICROSOFT_GRAPH_TENANT_ID,
      siteIds: /** @type {string[]} */ ([]),
    },
    prod: {
      clientId: MICROSOFT_GRAPH_CLIENT_ID,
      tenantId: MICROSOFT_GRAPH_TENANT_ID,
      siteIds: /** @type {string[]} */ ([]),
    },
  }

  return CONFIG_MAP[environment] ?? MICROSOFT_GRAPH_NOT_CONFIGURED
}

export const isLocalDevWithBackend = () => {
  return (
    isLocal() &&
    environment === ENVIROMENT_DEV &&
    process.env.IS_LOCAL_DEV === 'true'
  )
}

export default {
  isDevelopment,
  isStaging,
  isStg,
  isTesting,
  isDemo,
  isProduction,
  isLocal,
  getEnvironment,
  getEnvironmentPrefix,
  getPaymentServiceURL,
  getPaymentServiceKey,
  getLaunchDarklyConfig,
  isLocalDevWithBackend,
  getMicrosoftGraphConfig,
}
